import { defineFeature } from "../core/composition/define-feature.js";
import { recoverEndStall } from "../behaviors/dom/recover-end-stall.js";
//#region src/playback/features/end-stall-recovery.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [recoverEndStall];
/** The config defaults the feature contributes. */
const defaultConfig = {};
/** The state values the feature seeds. */
const initialState = {};
/**
* Fires the media element's `ended` when Chrome freezes the playhead a few frames short of the end of a stream whose
* audio and video end at slightly different times. Inert otherwise.
*/
const endStallRecoveryFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, defaultConfig, endStallRecoveryFeature, initialState };
